module.exports = __webpack_public_path__ + "1e44540e3cfe6ad390d224b5dd8d385e.webp";